


import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DomElementStyle} from '@/library/dom-element/dom-element-style';

Vue.component('vueCustomScrollbar', require('vue-custom-scrollbar'));

@Component({})
export default class AppScrollBox extends Vue {

  @Prop({default: false})
  public disabled!: boolean;

  @Watch('disabled', {immediate: false})
  public disabledChange(): void {
    this.checkContentFit();
  }

  public contentFitContainerX: boolean = false;
  public contentFitContainerY: boolean = false;
  private scrollBoxContentRef: HTMLElement | null = null;
  private customScrollbarRef: any | null = null;
  private localScrolling: boolean = false;
  private localTouching: boolean = false;
  private scrollingStateTimeoutHandler: any = null;

  public mounted(): void {
    this.scrollBoxContentRef = this.$refs.scrollBoxContent as HTMLElement;
    this.customScrollbarRef = this.$refs.customScrollbar;
    this.customScrollbarRef.ps.element.addEventListener('scroll', this.onScroll.bind(this));
    this.customScrollbarRef.ps.element.addEventListener('touchstart', this.onTouchStart.bind(this));
    this.customScrollbarRef.ps.element.addEventListener('touchend', this.onTouchEnd.bind(this));
    this.checkContentFit();
  }

  public unmounted(): void {
    this.customScrollbarRef.ps.element.removeEventListener('scroll', this.onScroll.bind(this));
    this.customScrollbarRef.ps.element.removeEventListener('touchstart', this.onTouchStart.bind(this));
    this.customScrollbarRef.ps.element.removeEventListener('touchend', this.onTouchEnd.bind(this));
  }

  public scrolling(): boolean {
    return this.localScrolling;
  }

  public scrolledTop(): boolean {
    return this.customScrollbarRef.ps.scrollbarYTop === 0;
  }

  public settings(): any {
    return {
      minScrollbarLength: 30,
      swipeEasing: true,
      suppressScrollX: this.disabled,
      suppressScrollY: this.disabled,
    }
  }

  public handleContentResize(): void {
    this.checkContentFit();
  }

  public handleContentVisibilityChanged(): void {
    this.checkContentFit();
  }

  private onScroll(): void {
    clearTimeout(this.scrollingStateTimeoutHandler);
    if (!this.disabled) {
      this.localScrolling = true;
      this.scrollingStateTimeoutHandler = setTimeout(() => {
        if (!this.localTouching) {
          this.localScrolling = false;
        }
      }, 500);
    }
  }

  private onTouchStart(): void {
    if (!this.disabled) {
      this.localTouching = true;
    }
  }

  private onTouchEnd(): void {
    clearTimeout(this.scrollingStateTimeoutHandler);
    this.localTouching = false;
    this.localScrolling = false;
  }

  private checkContentFit(): void {
    if (this.customScrollbarRef) {
      this.customScrollbarRef.update();
    }
    if (this.scrollBoxContentRef && this.scrollBoxContentRef.parentElement) {
      const contentSize = this.scrollBoxContentSize();
      const containerSize = this.scrollBoxContainerSize();
      this.contentFitContainerX = contentSize.width <= containerSize.width;
      this.contentFitContainerY = contentSize.height <= containerSize.height;
    }
  }

  private scrollBoxContentSize(): { width: number, height: number } {
    const size = {width: 0, height: 0};
    if (this.scrollBoxContentRef) {
      const style = new DomElementStyle(this.scrollBoxContentRef);
      size.width = style.width()
          + (style.margin().left + style.margin().right)
          + (style.border().left + style.border().right);
      size.height = style.height()
          + (style.margin().top + style.margin().bottom)
          + (style.border().top + style.border().bottom);
    }
    return size;
  }

  private scrollBoxContainerSize(): { width: number, height: number } {
    const size = {width: 0, height: 0};
    if (this.scrollBoxContentRef && this.scrollBoxContentRef.parentElement) {
      const style = new DomElementStyle(this.scrollBoxContentRef.parentElement);
      size.width = style.width() - (style.padding().left + style.padding().right);
      size.height = style.height() - (style.padding().top + style.padding().bottom);
    }
    return size;
  }
}
